import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListUl, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

export default class TBLIntegracoes extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.columns = [
      {
        Header: "Sistema",
        accessor: "nome",
        className: "center",
      },
      {
        Header: "Estabelecimento",
        accessor: "configuracoes.estabelecimento.nome_fantasia",
        className: "center",
      },
      {
        Header: "Ativo",
        accessor: "configuracoes.ativo",
        className: "center",
        Cell: (props) => <p>{!!props.value ? "Sim" : "Não"}</p>,
      },
      {
        Header: "Última Atualização de Preço",
        accessor: "configuracoes.data_update_preco",
        className: "center",
        Cell: (props) =>
          props.value ? (
            <span
              style={{
                backgroundColor:
                  moment(moment()).diff(props.value, "days") > 1 ? "#d62321" : "#b0e0a8",
              }}
            >
              {moment(props.value).format("DD/MM/YYYY HH:mm")}
            </span>
          ) : (
            <span>-</span>
          ),
      },
      {
        Header: "Ações",
        Cell: (row) => {
          return (
            <div>
              <Button
                size="sm"
                style={{ marginRight: 4 }}
                onClick={() => {
                  this.gerenciarAcoes("ver_itens", row.row._original);
                }}
              >
                <FontAwesomeIcon icon={faListUl}></FontAwesomeIcon>
              </Button>
              <Button
                size="sm"
                variant="danger"
                onClick={() => this.gerenciarAcoes("deletar", row.row._original)}
              >
                <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
              </Button>
            </div>
          );
        },
        className: "center",
      },
    ];
  }

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "ver_itens") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        className="-striped -highlight"
        columns={this.columns}
        resizable
        style={{ maxHeight: 572 }}
        showPagination={this.props.showPagination}
        defaultPageSize={this.props.numRows}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando..."
        noDataText="Nenhum dado encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLIntegracoes.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  numRows: PropTypes.number,
  dataCallback: PropTypes.func,
  isDespacho: PropTypes.bool,
};
